// src/App.jsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";
import EvidencePage from "./EvidencePage";
import HintsPage from "./HintsPage";
import RevealsPage from "./RevealsPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/evidence" element={<EvidencePage />} />
        <Route path="/hints" element={<HintsPage />} />
        <Route path="/reveals" element={<RevealsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

